// Route-level role guards, hoisted as stable module-level constants so
// ProtectedRoute's `allowedRoles` prop keeps a stable reference across
// renders instead of a brand-new array literal every time App re-renders
// (e.g. on route change).
export const ROLES_STAFF = ["admin", "office_staff"];
export const ROLES_ADMIN_ONLY = ["admin"];
export const ROLES_TIME_TRACKING = ["instructor", "office_staff", "admin"];
export const ROLES_EXPENSES = ["instructor", "office_staff", "admin"];
// v1.3: Classroom Roster — Owner/Admin & Office Staff manage all rosters;
// Instructors may view/manage only rosters for classes they teach
// (enforced again, authoritatively, by the backend permission check in
// routes_classroom_roster.py — this is just the route-guard allow-list).
export const ROLES_ROSTER = ["admin", "office_staff", "instructor"];
